import type { ThreadsActions } from '@store/reducers/threads'
import { InternalThreadsActions } from '@store/reducers/threads/actions'
import { SocketActions } from '@store/socketSaga'
import { call, put } from 'redux-saga/effects'

import API from '@/api'
import { GtmTriggerName, sendGtmEvent } from '@/constants/gtm'

export function* reopen({
  payload: { id },
}: ReturnType<typeof ThreadsActions.resolve>) {
  const action = InternalThreadsActions.update({ uuid: id, resolved: false })

  sendGtmEvent(GtmTriggerName.REOPEN_THREAD)

  yield put(action)

  yield call(API.Threads.unresolve, id)

  yield put(
    SocketActions.emit({
      eventName: 'comments',
      payload: action,
    })
  )
}
